import { render, staticRenderFns } from "./kpp_dashboard.vue?vue&type=template&id=06c71d26"
import script from "./kpp_dashboard.vue?vue&type=script&lang=js"
export * from "./kpp_dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports